import React from "react"
import styled from "styled-components"

const HeaderConvoWrapper = styled.div`
  display: flex;

  @media (max-width: 980px) {
    position: relative;
    transform: scale(0.8);
    right: 5%;
  }

  @media (max-width: 786px) {
    position: relative;
    transform: scale(0.8);
    right: 0%;
    margin-bottom: 100px;
  }

  @media (max-width: 420px) {
    position: relative;
    transform: scale(0.6);
    right: 0%;
    margin-bottom: 0px;
  }
`

const HeaderConvo = props => (
  <HeaderConvoWrapper>
    <img src={props.name} />
  </HeaderConvoWrapper>
)

export default ({ name }) => <HeaderConvo name={name} />



// WEBPACK FOOTER //
// ./src/components/HeaderConvo.js